export const getNumVisibleItems = () => {
  let computedVisibleItems = 4;
  const maxVisibleItems = 5;

  if (typeof window !== 'undefined') {
    if (window.innerWidth < 576) {
      return 1;
    }

    computedVisibleItems = Math.round(window.innerWidth / 336);
    console.log();
  }
  if (computedVisibleItems > maxVisibleItems) {
    return maxVisibleItems;
  }
  return computedVisibleItems;
};
